/* rl-countdown — drives any [data-rl-countdown] element with a data-target ISO date.
   Mounts once per element; survives theme-editor section reloads (clears prior
   intervals tracked on the element). */

(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function mount(root) {
    if (root.__rlCountdownInterval) {
      clearInterval(root.__rlCountdownInterval);
      root.__rlCountdownInterval = null;
    }
    var raw = root.getAttribute('data-target');
    var target = raw ? new Date(raw).getTime() : NaN;
    if (isNaN(target)) {
      console.warn('[rl-countdown] missing or unparseable data-target on', root);
      return;
    }
    var dEl = root.querySelector('[data-rl-d]');
    var hEl = root.querySelector('[data-rl-h]');
    var mEl = root.querySelector('[data-rl-m]');
    var sEl = root.querySelector('[data-rl-s]');
    if (!dEl || !hEl || !mEl || !sEl) return;

    function tick() {
      var ms = Math.max(0, target - Date.now());
      var s = Math.floor(ms / 1000);
      dEl.textContent = pad(Math.floor(s / 86400));
      hEl.textContent = pad(Math.floor((s % 86400) / 3600));
      mEl.textContent = pad(Math.floor((s % 3600) / 60));
      sEl.textContent = pad(s % 60);
      if (ms === 0 && root.__rlCountdownInterval) {
        clearInterval(root.__rlCountdownInterval);
        root.__rlCountdownInterval = null;
      }
    }
    tick();
    root.__rlCountdownInterval = setInterval(tick, 1000);
  }

  function mountAll(scope) {
    (scope || document).querySelectorAll('[data-rl-countdown]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  } else {
    mountAll();
  }

  // Theme-editor support: re-bind after a section reload.
  document.addEventListener('shopify:section:load', function (e) {
    mountAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-rl-countdown]').forEach(function (el) {
      if (el.__rlCountdownInterval) {
        clearInterval(el.__rlCountdownInterval);
        el.__rlCountdownInterval = null;
      }
    });
  });
})();
